import { ISetorDafForm } from '../../../../../modules/types/SetorDaf';

export const defaultSetorDafFormMain: ISetorDafForm = {
  id: 0,
  restricaoComponenteAf: 0,
  componenteAfId: 0,
  status: 0,
  sigla: '',
  nomeSetorDaf: '',
  dataCriacao: '',
  dataExtincao: '',
  descricao: '',
  observacoes: '',
};
